export interface GeneralReportEntity {

    reportType: string,
    reportId: string,
    printer: string,
    fileLocation: string,
    exportType?: string | null,
    masterCompanyCode?: string | null,
    companyCode?: string | null,
    customerCode?: string | null,
    activeInd?: string | null,
    criteriaType?: string | null,
    criteriaName?: string | null,
    docNoFrom?: string | null,
    docNoTo?: string | null,
    docDateFrom?: Date | null,
    docDateTo?: Date | null,
    opsDateFrom?: Date | null,
    opsDateTo?: Date | null,
    proposalNo?: string | null,
    effectiveDateFrom?: Date | null,
    effectiveDateTo?: Date | null,
    expiryDateFrom?: Date | null,
    expiryDateTo?: Date | null,
    glDateFrom?: Date | null,
    glDateTo?: Date | null,
    chargeOnCompany?: string | null,
    year?: string | null,
    month?: string | null,
    exceptionDateFrom?: Date | null,
    exceptionDateTo?: Date | null,
    exceptionType?: string | null,
    ediView?: string | null,
    chargeType?: string | null,
    date?: Date | null,
    proposalType?: string | null,
    proposalStatus?: string | null,
    version?: string | null,
    companyCodeFrom?: string | null,
    companyCodeTo?: string | null,
    proposalFrom?: string | null,
    proposalTo?: string | null,
    tariffNature?: string | null,
    tariffType?: string | null,

    vesselArrivalFromDate?: Date | null,
    vesselArrivalToDate?: Date | null,
    thcList?: string[] | null,
    shipmentTypeList?: string[] | null,
    containerSizeList?: string[] | null,
    containerStatusList?: string[] | null,
    type?: string | null,
    opsLineFrom?: string | null,
    opsLineTo?: string | null,
    consortiumCode?: string | null,
    vessleCode?: string | null,
    voyageCode?: string | null,
    billToCompany?: string | null,
    companyType?: string | null,
    companyNameList?: string[] | null,
    ntnNo?: string | null,
    amount?: number | null,
    transactionType?: string | null,
    transactionFromDate?: Date | null,
    transactionTomDate?: Date | null,
    depositAmount?: number | null,
    userId?: string | null,
    shipperConsignee?: string | null,
    shipperConsigneeCompanyName?: string | null,
    subType?: string | null,
    docType?: string | null,
    masterChargeOnCompany?: string | null,
    operatingTml?: string | null,
    serviceCode?: string | null,
    referenceFromDate?: Date | null,
    referenceTomDate?: Date | null,
    approvedFromDate?: Date | null,
    approvedTomDate?: Date | null,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    opsDate?: Date | null,
    viewList?: string[] | null,
    lpaCompanyCodeList?: string[] | null,
    //aqct /oict/RSCT
    settlementFromDate?: Date | null,
    settlementToDate?: Date | null,
    collFromDate?: Date | null,
    collToDate?: Date | null,
    cashierList?: string[] | null,
    shippingLineList?: string[] | null,
    tariffCodeList?: string[] | null,
    opsLine?: string | null,
    operatingUnit?: string | null,
    standardView?: string | null,
    creditView?: string | null,
    adjustmentView?: string | null

    [key: string]: string | boolean | Date | number | null | Object | undefined
}

export const EMPTY_GENERAL_REPORT_ENTITY: GeneralReportEntity = {
    reportType: "",
    reportId: "",
    printer: "",
    fileLocation: "",
    masterCompanyCode: null,
    companyCode: null,
    customerCode: null,
    activeInd: null,
    criteriaType: null,
    criteriaName: null,
    docNoFrom: null,
    docNoTo: null,
    docDateFrom: null,
    docDateTo: null,
    opsDateFrom: null,
    opsDateTo: null,
    proposalNo: null,
    effectiveDateFrom: null,
    effectiveDateTo: null,
    expiryDateFrom: null,
    expiryDateTo: null,
    glDateFrom: null,
    glDateTo: null,
    chargeOnCompany: null,
    year: null,
    month: null,
    exceptionDateFrom: null,
    exceptionDateTo: null,
    exceptionType: null,
    ediView: null,
    chargeType: null,
    date: null,
    proposalType: null,
    proposalStatus: null,
    version: null,
    companyCodeFrom: null,
    companyCodeTo: null,
    proposalFrom: null,
    proposalTo: null,
    tariffNature: null,
    tariffType: null,
    exportType: null,

    vesselArrivalFromDate: null,
    vesselArrivalToDate: null,
    thcList: [],
    shipmentTypeList: [],
    containerSizeList: [],
    containerStatusList: [],
    type: null,
    opsLineFrom: null,
    opsLineTo: null,
    consortiumCode: null,
    vessleCode: null,
    voyageCode: null,
    billToCompany: null,
    companyType: null,
    companyNameList: [],
    ntnNo: null,
    amount: null,
    transactionType: null,
    transactionFromDate: null,
    transactionTomDate: null,
    depositAmount: null,
    userId: null,
    shipperConsignee: null,
    shipperConsigneeCompanyName: null,
    subType: null,
    docType: null,
    viewList: [],
    masterChargeOnCompany: null,
    operatingTml: null,
    serviceCode: null,
    referenceFromDate: null,
    referenceTomDate: null,
    approvedFromDate: null,
    approvedTomDate: null,
    dateFrom: null,
    dateTo: null,
    opsDate: null,
    lpaCompanyCodeList: [],
    //AQCT/OICT/RSCT
    settlementFromDate: null,
    settlementToDate: null,
    collFromDate: null,
    collToDate: null,
    cashierList: [],
    shippingLineList: [],
    tariffCodeList: [],
    opsLine: null,
    operatingUnit: null,
    standardView: "Y",
    creditView: null,
    adjustmentView: null
}
